import {cloneDeep, sortBy, isEmpty, find, uniqBy} from 'lodash'
import constants from '@/libs/constant/constants'
import {message, errorHandler, logout, loader} from '@/libs/helper'

import {
    updateUserProfile,
    updateAuthor,
    uploadImage,
    getImageUploadURL,
    createAuthor,
    createPublisher,
    updatePublisher,
    updatePublication,
    createPublication,
    addAdminPublisher,
    API_BASE_URL
} from '@/libs/api/api'

const countrydata = require('countrydata');

export default{
    name: 'ManageAuthor',
    components: {
        ManageAuthor: () => import(/* webpackChunkName: "author" */ '../ManageAuthor/ManageAuthor.vue'),
        SearchAuthor: () => import(/* webpackChunkName: "author" */ '../SearchAuthor/SearchAuthor.vue'),
        ManageAuthorName: () => import(/* webpackChunkName: "author" */ '../ManageAuthorName/ManageAuthorName.vue'),
        ManageAuthorDescription: () => import(/* webpackChunkName: "author" */ '../ManageAuthorDescription/ManageAuthorDescription.vue'),
        ManageAuthorImage: () => import(/* webpackChunkName: "author" */ '../ManageAuthorImage/ManageAuthorImage.vue'),
    },
    props:{
        stepBack: {
            type: Function,
            default: ()=>{}
        },
        stepForward: {
            type: Function,
            default: ()=>{}
        },
        setClaimTo: {
            type: Function,
            default: ()=>{}
        },
        cancel: {
            type: Function,
            default: ()=>{}
        },
        claimTo: {
            type: Object,
            default: () => {}
        },
        isEdit: {
            type: Boolean,
            default: () => false
        },
        module: {
            type: String,
            default: () => constants.AUTHOR.key
        },
        isAdmin: {
            type: Boolean,
            default: false
        }
    },
    data(){
        return {
            countrydata,
            imageName: '',
            visibleCropDialog: false,
            imageCropperConfig: {
                img: '',
                autoCrop: true,
                autoCropWidth: 220,
                autoCropHeight: 220,
                fixedBox: true,
                canMoveBox: true,
                canMove: true

    },
            uploadImageData:{},
            platforms: [{type:'FACEBOOK', url: ''},{type:'LINKEDIN', url: ''},{type:'TWITTER', url: ''}],
            addedPlatform: this.$store.getters.getUserInformation.social_platforms || [],
            selectedPlatform: this.$store.getters.getUserInformation.social_platforms || [],
            // card: {
            //     // screen_name: this.$store.getters.getUserInformation.screen_name || '',
            //     website: this.$store.getters.getUserInformation.website || '',
            //     company: this.$store.getters.getUserInformation.company || '',
            //     description: this.$store.getters.getUserInformation.description || '',
            //     short_description: this.$store.getters.getUserInformation.short_description || ''
            // }
        }
    },
    methods: {
        /*
        * selectImageToUpload selects the image on the cropping window.
        * */
        selectImageToUpload (e, num) {
            let file = e.target.files[0]
            this.imageName = e.target.files[0].name
            let reader = new FileReader()
            reader.onload = (e) => {
                let data
                if (typeof e.target.result === 'object') {
                    data = window.URL.createObjectURL(new Blob([e.target.result]))
                } else {
                    data = e.target.result
                }
                if (num === 1) {
                    this.imageCropperConfig.img = data
                }
                this.visibleCropDialog =  !this.visibleCropDialog;
            }
            reader.readAsArrayBuffer(file)
        },
        /*
        * uploadImage() uploads the image to the s3 server
        * */
        uploadImageAuthorFlow(){
            loader(this, true);

            if(this.claimTo.imageBlobData === null){
                this.confirmAuthorFlow()
            }else{
                getImageUploadURL({imageName: this.claimTo.imageName})
                    .then((uploadUrl)=>{
                        this.uploadImageData = uploadUrl;
                        return uploadImage({imageData: this.claimTo.imageBlobData.imageData, uploadUrl })
                    }).then(()=>{
                    this.confirmAuthorFlow(this.uploadImageData.fileKey)
                }).catch((error)=> {
                    loader(this, false);
                    message(this, constants.messageType.ERROR, errorHandler(error, logout.bind(this, this)))
                });
            }
        },
        /*
        * uploadImage() uploads the image to the s3 server
        * */
        uploadImagePublisherFlow(){
            loader(this, true);

            if(this.claimTo.imageBlobData === null){
                if (this.isAdmin) {
                    this.confirmAdminPublisher()
                } else {
                    this.confirmPublisherFlow()
                }
                
            }else{
                getImageUploadURL({imageName: this.claimTo.imageName})
                    .then((uploadUrl)=>{
                        this.uploadImageData = uploadUrl;
                        return uploadImage({imageData: this.claimTo.imageBlobData.imageData, uploadUrl })
                    }).then(()=>{
                        if (this.isAdmin) {
                            this.confirmAdminPublisher(this.uploadImageData.fileKey)
                        } else {
                            this.confirmPublisherFlow(this.uploadImageData.fileKey)
                        }
                    
                }).catch((error)=> {
                    loader(this, false);
                    message(this, constants.messageType.ERROR, errorHandler(error, logout.bind(this, this)))
                });
            }
        },
        /*
        * uploadImage() uploads the image to the s3 server
        * */
        uploadImagePublicationFlow(){
            loader(this, true);

            if(this.claimTo.imageBlobData === null){
                this.confirmPublicationFlow()
            }else{
                getImageUploadURL({imageName: this.claimTo.imageName})
                    .then((uploadUrl)=>{
                        this.uploadImageData = uploadUrl;
                        return uploadImage({imageData: this.claimTo.imageBlobData.imageData, uploadUrl })
                    }).then(()=>{
                    this.confirmPublicationFlow(this.uploadImageData.fileKey)
                }).catch((error)=> {
                    loader(this, false);
                    message(this, constants.messageType.ERROR, errorHandler(error, logout.bind(this, this)))
                });
            }
        },
        /*
        * createBlobObject() creates and returns the binary image format to upload
        * */
        createBlobObject(uploadUrl, file){
            return new Promise((resolve) => {
                let reader = new FileReader(file)
                reader.addEventListener("loadend",function (data) {
                    return resolve({imageData: data.target.result, uploadUrl })
                });
                reader.readAsArrayBuffer(file);
            })
        },
        /*
        * update the user information.
        * */
        update(body){
            // if(this.card.screen_name === ''){
            //     message(this, constants.messageType.ERROR, 'Screen name field can not be blank');
            //     return
            // }
            loader(this, true);
            updateUserProfile(body)
                .then((response)=> {
                    if (response.id) {
                        message(this, constants.messageType.SUCCESS, ('Updated Successfully'));
                        this.$store.dispatch(constants.dispatch.SET_USER_INFORMATION_TO_STORE, response);
                    }
                    loader(this, false);
                })
                .catch((error)=> {
                    message(this, constants.messageType.ERROR, errorHandler(error, logout.bind(this, this)))
                    loader(this, false);
                })
        },
        updateSocialPlatform(platform, index, isRemove){
            loader(this, true);
            let addedPlatform = cloneDeep(this.addedPlatform)

            if(isRemove){
                addedPlatform = addedPlatform.filter(pf => pf.type !== platform.type)
            } else {
                addedPlatform[index] = platform
            }
            
            updateUserProfile({social_platforms: addedPlatform})
                .then((response)=> {
                    if (response.id) {
                        message(this, constants.messageType.SUCCESS, ('Updated Successfully'));
                        this.$store.dispatch(constants.dispatch.SET_USER_INFORMATION_TO_STORE, cloneDeep(response));
                    }
                    loader(this, false);
                })
                .catch((error)=> {
                    message(this, constants.messageType.ERROR, errorHandler(error, logout.bind(this, this)))
                    loader(this, false);
                })
        },
        selectPlatformToAdd(plateform){
            let selectedPlatform = cloneDeep(this.selectedPlatform)
            if (find(selectedPlatform, plateform)) {
                if (selectedPlatform.length !== 1) {
                    selectedPlatform = selectedPlatform.filter(f => f !== plateform.type)
                }
            } else {
                selectedPlatform.push(plateform)
            }
            this.selectedPlatform = cloneDeep(selectedPlatform)
        },
        addPlatform(){
            if(isEmpty(this.addedPlatform)){
                this.addedPlatform = this.selectedPlatform
            }else{
                this.addedPlatform = sortBy(uniqBy(this.addedPlatform.concat(this.selectedPlatform), 'type'), 'type')
            }
        },
        isDisabled (platform) {
            let socialPlatform = this.$store.getters.getUserInformation.social_platforms
            return find(socialPlatform, platform) ? true : false
        },
        isChecked (platform) {
            let addedPlatform = this.selectedPlatform
            return addedPlatform.filter(p => p.type === platform.type).length > 0
        },
        getURL(){
            return `${API_BASE_URL}/accounts/files/${this.$store.getters.getUserInformation.avatar_image}?auth=${localStorage.getItem('accuraAuthToken')}`
        },
        onError(e) {
            let avatarURL = require('../../../../../assets/images/img_avatar.png');
            if (e.target.src !== avatarURL) {
                e.target.src = avatarURL;
            }
        },
        /*
        * deletes the Avatar image.
        * */
        deleteAvatar(){
            loader(this, true);
            updateUserProfile({avatar_image:""})
                .then((response)=> {
                    if (response.id) {
                        message(this, constants.messageType.SUCCESS, ('Updated Successfully'));
                        this.$store.dispatch(constants.dispatch.SET_USER_INFORMATION_TO_STORE, response);
                    }
                    loader(this, false);
                })
                .catch((error)=> {
                    message(this, constants.messageType.ERROR, errorHandler(error, logout.bind(this, this)))
                    loader(this, false);
                })
        },
        confirmAuthorFlow(avatar_image){
            loader(this, true)
            let requestObject = cloneDeep(this.claimTo)
            delete requestObject._id;
            delete requestObject.name;
            requestObject.middle_name === '' ? delete requestObject.middle_name: null
            delete requestObject.is_following;
            delete requestObject.is_admin;
            delete requestObject.avatar_image;
            delete requestObject.type;
            delete requestObject.imageName;
            delete requestObject.imageBlobData;
            delete requestObject.imagePreview;
            delete requestObject.createdAt;
            delete requestObject.language;
            delete requestObject.publications;
            delete requestObject.updatedAt;

            delete requestObject.subtitle;
            delete requestObject.hideImage;
            delete requestObject.isNew;
            delete requestObject.website;

            this.claimTo.avatar_image = avatar_image || this.claimTo.avatar_image

            requestObject.avatar_image = avatar_image || this.claimTo.avatar_image
            requestObject.url = this.claimTo.url || this.claimTo.website
            requestObject.social_media.map((sm, index)=>{
                delete requestObject.social_media[index]._id
            })

            let body = requestObject

            if(this.claimTo.isNew){
                createAuthor(body)
                    .then((response)=>{
                        loader(this, false)
                        this.$store.dispatch('updateRegisteredAuthor', cloneDeep(response.result))
                        this.stepForward()
                    }).catch((error)=>{
                    loader(this, false)
                    message(this, constants.messageType.ERROR, (error.message))
                })
            }else{
                updateAuthor(body, this.claimTo._id)
                    .then(()=>{
                        loader(this, false)
                        this.$store.dispatch('updateRegisteredAuthor', cloneDeep(this.claimTo))
                        this.stepForward()
                    }).catch((error)=>{
                    loader(this, false)
                    message(this, constants.messageType.ERROR, (error.message))
                })
            }
        },
        confirmPublisherFlow(avatar_image){
            loader(this, true)
            let requestObject = cloneDeep(this.claimTo)
            delete requestObject._id;
            delete requestObject.last_name;
            requestObject.middle_name === '' ? delete requestObject.middle_name: null
            delete requestObject.is_following;
            delete requestObject.is_admin;
            delete requestObject.avatar_image;
            delete requestObject.type;
            delete requestObject.imageName;
            delete requestObject.imageBlobData;
            delete requestObject.file
            delete requestObject.imagePreview;
            delete requestObject.createdAt;
            delete requestObject.language;
            delete requestObject.publications;
            delete requestObject.authors;
            delete requestObject.updatedAt;

            delete requestObject.subtitle;
            delete requestObject.hideImage;
            delete requestObject.isNew;
            delete requestObject.website;

            requestObject.avatar_image = avatar_image || this.claimTo.avatar_image
            requestObject.url = this.claimTo.url[0] || this.claimTo.website[0]

            this.claimTo.avatar_image = avatar_image || this.claimTo.avatar_image
            
            requestObject.social_media.map((sm, index)=>{
                delete requestObject.social_media[index]._id
            })

            let body = requestObject

            if(this.claimTo.isNew){
                createPublisher(body)
                    .then((response)=>{
                        loader(this, false)
                        this.$store.dispatch('updateRegisteredPublisher', cloneDeep(response.result))
                        this.stepForward()
                    }).catch((error)=>{
                    loader(this, false)
                    message(this, constants.messageType.ERROR, (error.message))
                })
            }else{
                updatePublisher(body, this.claimTo._id)
                    .then(()=>{
                        loader(this, false)
                        this.$store.dispatch('updateRegisteredPublisher', cloneDeep(this.claimTo))
                        this.stepForward()
                    }).catch((error)=>{
                    loader(this, false)
                    message(this, constants.messageType.ERROR, (error.message))
                })
            }
        },
        confirmPublicationFlow(avatar_image){
            loader(this, true)
            let requestObject = cloneDeep(this.claimTo)
            delete requestObject._id;
            delete requestObject.last_name;
            requestObject.middle_name === '' ? delete requestObject.middle_name: null
            delete requestObject.is_following;
            delete requestObject.is_admin;
            delete requestObject.avatar_image;
            delete requestObject.type;
            delete requestObject.imageName;
            delete requestObject.imageBlobData;
            delete requestObject.imagePreview;
            delete requestObject.createdAt;
            delete requestObject.publisher;
            delete requestObject.authors;
            delete requestObject.updatedAt;

            delete requestObject.subtitle;
            delete requestObject.hideImage;
            delete requestObject.isNew;
            delete requestObject.website;
            delete requestObject.scrapped_name;

            this.claimTo.avatar_image = avatar_image || this.claimTo.avatar_image

            requestObject.avatar_image = avatar_image || this.claimTo.avatar_image
            requestObject.url = this.claimTo.website

            requestObject.social_media.map((sm, index)=>{
                delete requestObject.social_media[index]._id
            })

            let body = requestObject

            if(this.claimTo.isNew){
                createPublication(body)
                    .then((response)=>{
                        loader(this, false)
                        this.$store.dispatch('updateRegisteredPublication', cloneDeep(response.result))
                        this.stepForward()
                    }).catch((error)=>{
                    loader(this, false)
                    message(this, constants.messageType.ERROR, (error.message))
                })
            }else{
                updatePublication(body, this.claimTo._id)
                    .then(()=>{
                        loader(this, false)
                        this.$store.dispatch('updateRegisteredPublication', cloneDeep(this.claimTo))
                        this.stepForward()
                    }).catch((error)=>{
                    loader(this, false)
                    message(this, constants.messageType.ERROR, (error.message))
                })
            }
        },
        submitManageForm(module){
            switch (module){
                case constants.AUTHOR.key:
                    this.uploadImageAuthorFlow()
                    break
                case constants.PUBLISHER.key:
                    this.uploadImagePublisherFlow()
                    break
                case constants.PUBLICATION.key:
                    this.uploadImagePublicationFlow()
                    break
            }

        },
        confirmAdminPublisher (avatar_image) {
            loader(this, true)
            let requestObject = cloneDeep(this.claimTo)
            delete requestObject._id;
            delete requestObject.last_name;
            requestObject.middle_name === '' ? delete requestObject.middle_name: null
            delete requestObject.is_following;
            delete requestObject.is_admin;
            delete requestObject.avatar_image;
            delete requestObject.type;
            delete requestObject.imageName;
            delete requestObject.imageBlobData;
            delete requestObject.file
            delete requestObject.imagePreview;
            delete requestObject.createdAt;
            delete requestObject.language;
            delete requestObject.publications;
            delete requestObject.authors;
            delete requestObject.updatedAt;

            delete requestObject.subtitle;
            delete requestObject.hideImage;
            delete requestObject.isNew;
            delete requestObject.website;
            if (!isEmpty(avatar_image)) {
                requestObject.avatar_image = avatar_image
            }
            
            requestObject.url = this.claimTo.url[0] || this.claimTo.website[0]

            this.claimTo.avatar_image = avatar_image || this.claimTo.avatar_image
            
            requestObject.social_media.map((sm, index)=>{
                delete requestObject.social_media[index]._id
            })

            let body = requestObject

            if(this.claimTo.isNew){
                addAdminPublisher(body).then(() => {
                    loader(this, false)
                    this.stepForward()
                }).catch((error)=>{
                loader(this, false)
                message(this, constants.messageType.ERROR, (error.message))
                })
            }
        }
    }
}